import {
  //
  ADD_REVIEWS_REPLY,
  ADD_REVIEWS_REPLY_FAILURE,
  ADD_REVIEWS_REPLY_SUCCESS,
  //
  DELETE_REVIEWS_REPLY,
  DELETE_REVIEWS_REPLY_FAILURE,
  DELETE_REVIEWS_REPLY_SUCCESS,
  //
  EDIT_REVIEWS_REPLY,
  EDIT_REVIEWS_REPLY_FAILURE,
  EDIT_REVIEWS_REPLY_SUCCESS,
  //
  FETCH_REVIEWS_REPLY,
  FETCH_REVIEWS_REPLY_FAILURE,
  FETCH_REVIEWS_REPLY_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchReviewsReply = (payload) => ({
  type: FETCH_REVIEWS_REPLY,
  payload,
});
export const fetchReviewsReplySuccess = (payload) => ({
  type: FETCH_REVIEWS_REPLY_SUCCESS,
  payload,
});
export const fetchReviewsReplyFailure = (payload) => ({
  type: FETCH_REVIEWS_REPLY_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addReviewsReply = (payload) => ({
  type: ADD_REVIEWS_REPLY,
  payload,
});
export const addReviewsReplySuccess = (payload) => ({
  type: ADD_REVIEWS_REPLY_SUCCESS,
  payload,
});
export const addReviewsReplyFailure = (payload) => ({
  type: ADD_REVIEWS_REPLY_FAILURE,
  payload,
});
// EDIT
export const editReviewsReply = (payload) => ({
  type: EDIT_REVIEWS_REPLY,
  payload,
});
export const editReviewsReplySuccess = (payload) => ({
  type: EDIT_REVIEWS_REPLY_SUCCESS,
  payload,
});
export const editReviewsReplyFailure = (payload) => ({
  type: EDIT_REVIEWS_REPLY_FAILURE,
  payload,
});
// DELETE
export const deleteReviewsReply = (payload) => ({
  type: DELETE_REVIEWS_REPLY,
  payload,
});
export const deleteReviewsReplySuccess = (payload) => ({
  type: DELETE_REVIEWS_REPLY_SUCCESS,
  payload,
});
export const deleteReviewsReplyFailure = (payload) => ({
  type: DELETE_REVIEWS_REPLY_FAILURE,
  payload,
});
